import { z } from "zod";
import {
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  COMMUNITY_NAME,
  COMMUNITY_REGISTERED_NAME,
  CONTACT_EMAIL,
  EMERGENCY_PHONE,
  GENERAL_PHONE,
  LANGUAGE,
  MANAGER_NAME,
  MANAGER_PHONE,
  STATE,
  UNITS,
  WEBSITE,
  ZIPCODE,
} from "./consts";

export const schema = z.object({
  [COMMUNITY_NAME]: z
    .string()
    .min(3, "Please fill community Name")
    .max(30, "Community Name should be less than 30 characters"),
  [COMMUNITY_REGISTERED_NAME]: z
    .string()
    .optional()
    .refine((val) => !val || (val.length >= 3 && val.length <= 30), {
      message: "Must be between 3 and 30 characters",
    }),
  [LANGUAGE]: z.string().optional(),
  [UNITS]: z.string().optional(),
  [ADDRESS_1]: z.string().min(1, "Please fill address"),
  [ADDRESS_2]: z.string().optional(),
  [ZIPCODE]: z.string().regex(/^[0-9]{5}-[0-9]{4}$/, "Enter ZIP code in XXXXX-XXXX format."),
  [STATE]: z.string().min(1, "Please fill state"),
  [CITY]: z.string().min(1, "Please fill city"),
  [GENERAL_PHONE]: z
    .string()
    .min(10, "Please fill general phone number")
    .regex(/^\+[1-9][0-9]{6,14}$/, "Invalid Phone Number")
    .optional(),
  [EMERGENCY_PHONE]: z
    .string()
    .min(10, "Please fill emergency phone number")
    .regex(/^\+[1-9][0-9]{6,14}$/, "Invalid Phone Number"),
  [MANAGER_NAME]: z.string().optional(),
  [MANAGER_PHONE]: z.string().optional(),
  [CONTACT_EMAIL]: z
    .string()
    .min(1, "Please fill contact email")
    .email("This is not a valid email."),
  [WEBSITE]: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!val) return true; // Skip validation if empty
        return /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)*$/.test(val);
      },
      {
        message: "Invalid URL",
      }
    ),
});

export type formValues = z.infer<typeof schema>;
